import { IEnv } from '../app/core/interface/app-interface';

export const environment: IEnv = {
  loggingEnabled: false,
  production: true,
  name: 'production',
  local: false,
  visibility: 'nitto',
};
